
export const createDepartment = async ({BeURL,department}) => {
    try{
        const response = await fetch(`${BeURL}/department`,{
            method: 'POST',
            headers: {  
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({department})
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("Error in creating department:", error);
        return {
            success: false,
            message: "Server not reachable",
        };
    }
}
